import React, { ReactNode } from 'react'

interface IWindowOpenProps {
  to?: string
  onClick?: () => void
  children?: ReactNode
}

export function WindowOpen({ to, onClick, children }: IWindowOpenProps) {
  return (
    <div
      style={{ cursor: 'pointer' }}
      onClick={() => {
        if (onClick) {
          onClick()
        }
        window.open(to)
      }}
    >
      {children}
    </div>
  )
}
